@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/text';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/decorative';
@forward '@raspberrypifoundation/design-system-core/scss/properties/spacing';
@forward '@raspberrypifoundation/design-system-core/scss/properties/sizing';
@forward '@raspberrypifoundation/design-system-core/scss/properties/border';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/brand';
@forward '../../global/styles';

@use '@raspberrypifoundation/design-system-core/scss/mixins/typography' as typography;

:host {
  --active-border-color: var(--rpf-brand-raspberry);

  margin-block-end: auto;
}

.rpf-links {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  list-style: none;
  margin-block: 0;
  margin-inline: 0;
  padding-inline: 0;

  &__link {
    @include typography.style-1-5(bold);

    align-items: center;
    border-block-end: 3px solid transparent;
    border-block-start: 3px solid transparent;
    border-radius: var(--border-radius-sm);
    color: var(--text-color);
    display: inline-flex;
    min-block-size: calc(var(--min-target-size) - 6px);
    padding-inline: var(--space-0-5);
    position: relative;
    text-decoration: none;

    &::after {
      block-size: 3px;
      border-radius: 0;
      content: '';
      inset-block-end: 0;
      inset-inline: 0;
      position: absolute;
    }

    &:hover::after {
      background-color: var(--rpf-grey-100);
    }

    &:focus-visible {
      outline: solid var(--border-width-md) var(--focus-border-color, --rpf-brand-raspberry);
    }

    &:active::after,
    &.active::after {
      background-color: var(--active-border-color);
    }
  }

  &__list-item {
    &:nth-child(1) {
      --active-border-color: var(--rpf-teal-800);
    }

    &:nth-child(2) {
      --active-border-color: var(--rpf-purple-800);
    }

    &:nth-child(3) {
      --active-border-color: var(--rpf-orange-800);
    }

    &:nth-child(4) {
      --active-border-color: var(--rpf-blue-800);
    }

    &:nth-child(5) {
      --active-border-color: var(--rpf-raspberry-800);
    }
  }

  @container (min-width: 77.5rem) {
    flex-direction: row;
    gap: var(--space-4);
  }
}
